import { Box, Text } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useModalState } from '~/atoms/ModalState'
import { MangoButton } from '~/components/shared/MangoButton'
import { MangoModal } from '~/components/shared/MangoModal'
import { useAnalytics } from '~/hooks/useAnalytics'
import { AnalyticsNamespace, MessagingAnalyticsEvents } from '~/types/Analytics'
import { Size } from '~/types/ThemeTypes'
import { useMessageGroupsViewModel } from '~/viewModels/Messaging/MessageGroupsViewModel'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

const MarkReadModal = () => {
  const { messagingMarkAllReadModal: chatMarkAllReadModal } = useModalState()
  const { markAllMessageGroupsAsRead } = useMessageGroupsViewModel()
  const { track } = useAnalytics(AnalyticsNamespace.MESSAGING)
  const { t } = useTranslation()

  const [renderState, setRenderState] = chatMarkAllReadModal
  const handleCloseModal = () => {
    setRenderState({ ...renderState, open: false })
  }

  const handleMarkAsRead = () => {
    markAllMessageGroupsAsRead()
    handleCloseModal()
    track(MessagingAnalyticsEvents.MarkAllAsRead)
  }

  return (
    <MangoModal
      open={renderState.open}
      size={Size.md}
      header={t('markReadModal.header')}
      onOpenChange={(details) => {
        if (!details.open) handleCloseModal()
      }}
      footer={
        <MangoButton onClick={handleMarkAsRead}>
          {t('markReadModal.confirmButton')}
        </MangoButton>
      }
    >
      <Box minHeight="3rem">
        <Text {...textStyles[textStyleKeys.Body1]} textAlign="center">
          {t('markReadModal.message')}
        </Text>
        <Text {...textStyles[textStyleKeys.Body1]} textAlign="center">
          {t('markReadModal.confirmText')}
        </Text>
      </Box>
    </MangoModal>
  )
}

export default MarkReadModal
